module.exports = __webpack_public_path__ + "img/cats3.f4bc950b.jpg";